import { render, staticRenderFns } from "./Reminders.handler.vue?vue&type=template&id=6cb4d354&"
import script from "./Reminders.handler.vue?vue&type=script&lang=ts&"
export * from "./Reminders.handler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports